export const SHORT_DESCRIPTION_MAX = 120

export const DEVELOPER_DOCS_URL = import.meta.env.REACT_APP_DOCS_URL

export const MCP_KNOWLEDGEBASE_URL = 'https://help.zocks.io/en/articles/15331595-zocks-mcp-server-knowledge-base'

export const MCP_HELP_ARTICLE_URL = 'https://help.zocks.io/en/collections/19244570-zocks-mcp-server'

export const MCP_WHAT_YOU_CAN_DO_ARTICLE_URL = 'https://help.zocks.io/en/articles/16886501-what-you-can-do-with-the-zocks-mcp'

// TODO(pii-shield): point to a dedicated PII Shield help article once one is published.
export const PII_SHIELD_LEARN_MORE_URL = MCP_KNOWLEDGEBASE_URL

// Early-access request form opened by the "Request access" button.
// TODO(pii-shield): replace with the real Typeform URL once it is published.
export const PII_SHIELD_REQUEST_ACCESS_URL = 'https://form.typeform.com/to/REPLACE_ME'

export const INTEGRATIONS_CONTACT_EMAIL = 'integrations@zocks.io'

// Scopes that cannot be self-selected and require contacting the integrations team.
export const CONTACT_REQUIRED_SCOPE_IDS = ['file:download']

export const SUPPORTED_CONTRACT_VERSIONS = ['v1']
export const DEFAULT_TIMEOUT_MS = 2500
export const MIN_TIMEOUT_MS = 100
export const MAX_TIMEOUT_MS = 5000
export const MAX_DESCRIPTION_LENGTH = 500

const EXTERNAL_DATA_SOURCE_DOCS = DEVELOPER_DOCS_URL ? `${DEVELOPER_DOCS_URL.replace(/\/+$/, '')}/docs/guides/external-data-sources` : ''

export const DOCS_LINKS = {
  overview: EXTERNAL_DATA_SOURCE_DOCS && `${EXTERNAL_DATA_SOURCE_DOCS}/overview`,
  quickstart: EXTERNAL_DATA_SOURCE_DOCS && `${EXTERNAL_DATA_SOURCE_DOCS}/quickstart`,
  contract: EXTERNAL_DATA_SOURCE_DOCS && `${EXTERNAL_DATA_SOURCE_DOCS}/the-contract`,
  declaringAuth: EXTERNAL_DATA_SOURCE_DOCS && `${EXTERNAL_DATA_SOURCE_DOCS}/declaring-auth`,
}
